import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-items-page',
  templateUrl: './service-items-page.component.html',
  styleUrls: ['./service-items-page.component.css']
})
export class ServiceItemsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/service-items/service-items-page/service-items-page.component.ts